export default "__VITE_ASSET__LdZbWrxF__"